import React from 'react';
import classnames from 'classnames';
import { usePagination } from './UsePagination';

// example ref https://www.freecodecamp.org/news/build-a-custom-pagination-component-in-react/

const Pagination = props => {
  const {
    className,
    currentPage,
    totalCount,
    pageSize,
    onPageChange
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <div className={className}>
        <ul
        className={classnames('pagination__list', { [className]: className })}
        >
        <li className="pagination__item">
            <button 
                type="button" 
                className="pagination__page pagination__page--prev"
                onClick={onPrevious} 
                aria-label="Previous Page" 
                disabled={currentPage === 1}
                >
                <svg class="icon" focusable="false" aria-hidden="true">
                    <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-arrow_back"></use>
                </svg>
            </button>
        </li>
        {paginationRange.map(pageNumber => {
            return (
            <li className="pagination__item">
                <button 
                    type="button"
                    className={classnames('pagination__page', { selected: pageNumber === currentPage})}
                    aria-label={`Go to Page ${pageNumber}`}
                    onClick={() => onPageChange(pageNumber)} 
                    >
                    {pageNumber}
                </button>
            </li>
            );
        })}
        <li className="pagination__item">
            <button 
                type="button" 
                className="pagination__page pagination__page--next"
                onClick={onNext}
                aria-label="Next Page" 
                disabled={currentPage === lastPage}
                >
                <svg class="icon" focusable="false" aria-hidden="true">
                    <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-arrow_forward"></use>
                </svg>
            </button>
        </li>
        </ul>
    </div>
  );
};

export default Pagination;
